import { render, staticRenderFns } from "./app-popup-message.vue?vue&type=template&id=82b9563a&"
import script from "./app-popup-message.vue?vue&type=script&lang=js&"
export * from "./app-popup-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports